// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2ldiE","actionsCol":"EnrolledClinics_actionsCol__3Mm4g"};